// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StandoutText_wrapper__sE_zC","column":"StandoutText_column__u4VlF","inner":"StandoutText_inner__QThNI","hasTitle":"StandoutText_hasTitle__3YEEc"};